<div class="wrapper h-full flex flex-col">
  <!-- Header -->
  <div class="heading text-type-2 mb-[20px] flex flex-row justify-between items-center">
    <div class="counter text-type-2">Add station</div>
    <mat-icon (click)="close()">close</mat-icon>
  </div>
  <div class="details flex-1">
    @for (sff of stationFormFields; track sff) {
      @switch (sff?.type) {
        <!-- TYPE: STRING -->
        @case ('string') {
          @if (sff?.name === 'offset_type') {
            <!-- Offset Type → Dropdown -->
            <app-dropdown
              (checkForErrors)="checkForErrors($event)"
              [controlName]="sff?.name"
              [error]="errorMessages[sff?.name]"
              [label]="sff?.label"
              [options]="offsetTypeOptions"
              [parentFormGroup]="stationForm"
              class="mb-[20px]">
            </app-dropdown>
          } @else {
            <app-text-input
              (checkForErrors)="checkForErrors($event)"
              [controlName]="sff?.name"
              [error]="errorMessages[sff?.name]"
              [label]="sff?.label + (sff?.uom ? ' (' + sff?.uom + ')' : '')"
              [parentFormGroup]="stationForm"
              class="mb-[20px]">
            </app-text-input>
          }
          <!-- All other string fields → Text Input -->
        }
        <!-- TYPE: NUMBER -->
        @case ('number') {
          <app-number-input
            (checkForErrors)="checkForErrors($event)"
            [controlName]="sff?.name"
            [error]="errorMessages[sff?.name]"
            [label]="sff?.label + (sff?.uom ? ' (' + sff?.uom + ')' : '')"
            [parentFormGroup]="stationForm"
            class="mb-[20px]">
          </app-number-input>
        }
      }
    }
  </div>
  <div class="action-section w-full flex flex-row justify-start items-center">
    <app-primary-button
      (handleClick)="add()"
      class="w-full">
      Add
    </app-primary-button>
  </div>
</div>
